import React from "react";
import { UseLinklyPosReturn } from "./types";

export type LinklyPosProviderProps = {
  children: React.ReactNode;
} & UseLinklyPosReturn;

const LinklyPosContext = React.createContext<UseLinklyPosReturn | null>(null);

export const useLinklyPosContext = () =>
  React.useContext(LinklyPosContext) as UseLinklyPosReturn;

export const LinklyPosProvider = (props: LinklyPosProviderProps) => {
  const { children, ...data } = props;
  return (
    <LinklyPosContext.Provider value={data as unknown as UseLinklyPosReturn}>
      {children}
    </LinklyPosContext.Provider>
  );
};
